var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mycontent", class: { minWidth: _vm.isCollapse } },
    [
      _c("el-scrollbar", [
        _c(
          "div",
          { staticClass: "main", style: { minHeight: _vm.pageheight + "px" } },
          [
            _c(
              "transition",
              { attrs: { name: "fade-transform", mode: "out-in" } },
              [_c("router-view")],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }